/**
 * 카테고리명 한→영 표시 매핑 (i18n 3단계)
 * DB·필터 값은 한글 유지, 화면 표시만 언어에 따라 변환
 */
import i18n from './index';

const CATEGORY_EN: Record<string, string> = {
  // categories 테이블 (서비스/프로젝트 공통)
  '웹 개발': 'Web Development',
  '모바일 앱': 'Mobile Apps',
  '디자인': 'Design',
  '마케팅': 'Marketing',
  '글쓰기': 'Writing',
  '번역': 'Translation',
  '영상 편집': 'Video Editing',
  '기타': 'Other',
  // serviceAPI.getCategories 라벨
  '개발/프로그래밍': 'Development/Programming',
  '글쓰기/번역': 'Writing/Translation',
  '영상/사진': 'Video/Photo',
  '음악/오디오': 'Music/Audio',
  '비즈니스 컨설팅': 'Business Consulting',
  // ProjectCreatePage 카테고리 라벨
  '개발·프로그래밍': 'Development/Programming',
  '글쓰기·번역': 'Writing/Translation',
  '영상·사진': 'Video/Photo',
  '음악·오디오': 'Music/Audio',
  // ProjectCreatePage 하위 분야
  '로고·브랜딩': 'Logo & Branding',
  '상세·이벤트페이지': 'Detail/Event Pages',
  'PPT·인포그래픽': 'PPT & Infographics',
  '캐릭터·이모티콘': 'Characters & Emoticons',
  '웹사이트': 'Websites',
  '모바일앱': 'Mobile Apps',
  '프로그램': 'Programs',
  '블록체인': 'Blockchain',
  'SNS 마케팅': 'SNS Marketing',
  '광고 운영': 'Ad Operations',
  '바이럴 마케팅': 'Viral Marketing',
  '블로그·콘텐츠': 'Blog & Content',
  '네이밍': 'Naming',
  '원고·자료 작성': 'Copy & Documents',
  '영상 촬영': 'Video Shooting',
  '사진 촬영': 'Photography',
  '사진 편집': 'Photo Editing',
  '작곡·편곡': 'Composing & Arranging',
  '보컬·가이드': 'Vocals & Guides',
  '믹싱·마스터링': 'Mixing & Mastering',
  '더빙·내레이션': 'Dubbing & Narration',
  '법률 자문': 'Legal Advice',
  '세무·회계': 'Tax & Accounting',
  '특허·상표': 'Patents & Trademarks',
  'HR·노무': 'HR & Labor',
};

/** 현재 언어가 영어면 매핑된 영문명, 아니면(또는 매핑 없으면) 원문 반환 */
export const categoryLabel = (name?: string | null): string => {
  if (!name) return '';
  const lng = (i18n as unknown as { language?: string }).language || 'en';
  if (lng.startsWith('ko')) return name;
  return CATEGORY_EN[name] || name;
};
